import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getInventoryListWidgetStyles = () => {
  var imageHeightSize = 64;
  var imageWidthSize = 115;
  return StyleSheet.create({
    cardContainerOuter: {
      position: 'relative',
      flex: 1
    },
    cardContainer: {
      paddingBottom: tokens.spacing.SPACING_30,
      marginBottom: tokens.spacing.SPACING_14,
      flex: 1
    },
    buttonContainer: {
      position: 'absolute',
      bottom: 0
    },
    imageContainer: {
      height: imageHeightSize,
      width: imageWidthSize,
      flexShrink: 0
    }
  });
};